<script lang="ts">
  import { onDestroy, onMount } from 'svelte'
  import i18n from '../../../i18n'
  import { DateTime } from 'luxon'
  import { Loader } from '@lucide/svelte'

  type Props = {
    updatedAt?: string
    isLoading?: boolean
  }

  const { updatedAt, isLoading }: Props = $props()
  let timeAgo = $state<string | null>(null)
  let isJustNow = $state(false)

  let interval: NodeJS.Timeout

  const setLabel = () => {
    if (updatedAt) {
      const dt = DateTime.fromISO(updatedAt)
      const diffSeconds = Math.abs(DateTime.now().diff(dt, 'seconds').seconds)
      if (diffSeconds < 60) {
        isJustNow = true
        timeAgo = null
      }
      else {
        isJustNow = false
        timeAgo = dt.toRelative({ unit: ['days', 'hours', 'minutes'] })
      }
    }
    else {
      isJustNow = false
      timeAgo = null
    }
  }

  $effect(() => {
    setLabel()
  })

  onMount(() => {
    interval = setInterval(setLabel, 30000)
  })

  onDestroy(() => {
    clearInterval(interval)
  })
</script>

<span class="time-updated-at">
  {#if isLoading}
    <div class="loading">
      <Loader size={16} />
    </div>
    {$i18n.t('project.saving')}
  {:else if isJustNow}
    {$i18n.t('project.savedJustNow')}
  {:else if timeAgo}
    {$i18n.t('project.savedTimeAgo', { timeAgo })}
  {/if}
</span>

<style lang="scss">
  .time-updated-at {
    color: var(--foreground-muted);
    font-size: 0.625rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;

    .loading {
      display: flex;
      font-size: 0.5rem;
      animation: spin 2s linear infinite;

      :global(svg) {
        min-width: 0.625rem;
        min-height: 0.625rem;
        width: 0.625rem;
        height: 0.625rem;
      }
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
